// extracted by mini-css-extract-plugin
export default {"defectSelection":"DefectSelection_tsx_defectSelection__hS1Nj"};